import { useRef, useEffect, useState } from 'react';
import './style.scss';
import { TranslationService } from '../../../../../../services/translation.service';

function CountDownBar({
  signCount,
  maximumSignAttempts,
  allowSignExtension,
  className,
  extendSign,
}: {
  signCount: number;
  maximumSignAttempts: number;
  allowSignExtension: boolean;
  className?: string;
  extendSign: () => void;
}) {
  const initialTimeLeft = 60;
  const [timeLeft, setTimeLeft] = useState(initialTimeLeft);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const showExtendSignButton = timeLeft <= 30 && allowSignExtension;

  useEffect(() => {
    if (maximumSignAttempts - signCount === 1) {
      startCountdown(initialTimeLeft);
    }
  }, [maximumSignAttempts, signCount]);

  function startCountdown(initialTime: number) {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    setTimeLeft(initialTime);
    intervalRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(intervalRef.current!);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  }

  // NV-7126: This is bot for showing in text and for visually impared users that needs to be informed about the time left
  function getDisplayText(time: number): string {
    if (time <= 60 && time > 30) {
      return TranslationService.get('delaycompensationformpage.sign.lessthanoneminuteleft');
    } else if (time <= 30 && time > 20) {
      return TranslationService.get('delaycompensationformpage.sign.lessthanthirtysecondsleft');
    } else if (time <= 20 && time > 10) {
      return TranslationService.get('delaycompensationformpage.sign.lessthantwentysecondsleft');
    } else if (time === 10) {
      return `${time} ${TranslationService.get('delaycompensationformpage.sign.secondsleft')}`;
    } else {
      return `${time}`;
    }
  }

  return (
    <div className={`count-down-bar-wrapper ${className}`}>
      <div className="progress rounded-pill mb-1">
        <div className="progress-bar" role="progressbar" style={{ width: `${(timeLeft / initialTimeLeft) * 100}%` }} aria-valuenow={timeLeft} aria-valuemin={0} aria-valuemax={initialTimeLeft}></div>
      </div>
      <div className="time-left">
        <span className="time-left__text" role="alert">
          {getDisplayText(timeLeft)}
        </span>
      </div>
      <span className="visually-hidden" id="extendSignButtonDescription" aria-live="assertive">
        {showExtendSignButton && TranslationService.get('delaycompensationformpage.sign.extendsignbuttondescription')}
      </span>
      {showExtendSignButton && (
        <>
          <button className="btn btn-primary mt-2 w-100" aria-describedby="extendSignButtonDescription" onClick={extendSign}>
            {TranslationService.get('delaycompensationformpage.sign.extend')}
          </button>
        </>
      )}
    </div>
  );
}

export default CountDownBar;
